import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    return (
        <details
            class="accordion group ns-px-4 ns-p-l-0"
            is="accordion-disclosure"
            aria-expanded={`${active ? "true" : "false"}`}
            open={active}
            onToggle={e => setActive(e.currentTarget.open)}
        >
            <summary>
                <span class="accordion__toggle font-serif text-sm uppercase tracking-wide">
                    <span class="text-with-icon gap-4">{facet.name}</span>
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        fill="none"
                        width="10"
                        class="group-expanded:rotate icon icon-chevron-down"
                        viewBox="0 0 10 10"
                    >
                        <path
                            d="m1 3 4 4 4-4"
                            stroke="currentColor"
                            stroke-linecap="square"
                        ></path>
                    </svg>
                </span>
            </summary>
            <div class="accordion__content">
                <div class="v-stack gap-2.5">
                    <div class="flex gap-4">
                        <div class="flex-1">
                            <label
                                for={`ns-${facet.id}-min`}
                                class="ns-form-label text-xs"
                            >
                                Min.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value =
                                        parseFloat(e.currentTarget.value) ||
                                        undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="flex-1">
                            <label
                                for={`ns-${facet.id}-max`}
                                class="ns-form-label text-xs"
                            >
                                Max.
                            </label>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value =
                                        parseFloat(e.currentTarget.value) ||
                                        undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>
                    <RangeSlider id={facet.id} />
                </div>
            </div>
        </details>
    )
}
